<template>
  <div class="success">
    <div class="text-1">
      Thank you for booking with
      <span class="name"
        >{{ serviceDetail.lastName }} {{ serviceDetail.firstName }}</span
      >
    </div>
    <div class="text-2">
      We sent your request to photographer who will reply you shortly,<br />
      Payment will not go thoguth until the photographer accept your request
    </div>
    <div class="text-3">
      <base-button-type-1
        text="MY ACCOUNT"
        @click="myAccount"
      ></base-button-type-1>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseButtonType1 from '../common/form-elemnets/BaseButtonType1'
import * as types from '../../store/mutation-types'

export default {
  components: { BaseButtonType1 },
  name: 'success',
  methods: {
    myAccount() {
      alert('Thank you')
      this.$store
        .dispatch(types.SET_MODAL_COMPONENT, {
          component: '',
          active: false,
          type: 'full'
        })
        .then(() => {
          this.$router.push({ path: 'user/booking' })
        })
    }
  },
  computed: {
    ...mapGetters(['serviceDetail'])
  }
}
</script>

<style lang="scss" scoped>
.success {
  border: 1px solid lightgray;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 98%;
  height: 600px;
  justify-content: center;
  .text-1 {
    width: 480px;
    height: 104px;
    font-size: 2.2rem;
    font-weight: 500;
    text-align: center;
    .name {
      line-height: 80px;
      font-weight: 600;
    }
  }

  .text-2 {
    margin-top: 20px;
    display: block;
    text-align: center;
    width: 600px;
    height: 80px;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  .text-3 {
    margin-top: 5px;
    .base-button-type-1 {
      width: 200px;
    }
  }
}
</style>
